import styled from '@emotion/styled';
interface PageImageProps {
    width?: number;
    height?: number;
}

export const PageImage = styled.img<PageImageProps>(({ width = 300, height = 300 }) => ({
    width,
    height,
}));
